import { SAVE_CABIN_OPTION } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'

/**
 * Leaf action for invalidating cruise cabin pricing after traveller form changes.
 * Kept out of CruiseActions so CheckoutActions can dispatch it without the
 * CheckoutActions ↔ CruiseActions cycle.
 */
export function saveCabinOptions(cruiseItemId: string): AppAction {
  return {
    type: SAVE_CABIN_OPTION,
    cruiseItemId,
  }
}
